<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card">
      <div class="close cursor-pointer" @click="$emit('cancel')"><i class="fal fa-times"></i></div>
      <header class="title">
        <h2>{{ $t('navBar.logout') }}</h2>
      </header>
      <section class="body">
        <p>{{$t('projectActions.logoutConfirm')}}</p>
      </section>
      <footer class="is-flex">
        <div class="button-container">
          <a qa="logoutConfirmButton" class="button is-primary" @click="$emit('logout')">
            {{ $t('navBar.logout') }}
          </a>
        </div>
      </footer>
    </aside>
  </div>
</template>

<script>
import ModalCustom from '@/components/Modals/Custom'

export default {
  components: {
    ModalCustom
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $modal-body-color: #F2F2F2;
  $error-message-height: 24px;
  $close-icon-color: #1A051D;

  .modal-card {
    background: $modal-body-color;
    text-align: center;
    // HEADER
    .title {
      font-size: 1.5rem;
      font-weight: 400;
      border-bottom: 1px solid #DCDCDC;
      h2 {
        font-family: $primary-font;
        font-weight: $primary-font-weight;
        padding: 1.3rem 0;
      }
    }
  }

  .body,
  footer {
    width: 70%;
    max-width: 350px;
    margin: 0 auto;
  }

  .body {
    padding: 1rem 0;
    font-size: 1.2rem;
  }

  .is-flex {
    flex-direction: column;
  }

  .button-container {
    align-items: center;

    .button {
      flex: 0 0 auto;
      margin: 1.5rem 0 2.5rem;
      border-radius: 0;
      padding: 1.2rem 1.6rem;
      text-transform: uppercase;
      font-size: 0.9rem;
    }
  }

  .close {
    color: $close-icon-color;;
    position: absolute;
    right: 1rem;
    top: 0.4rem;
    z-index: 5;
    font-size: 1.5rem;
    font-weight: 300;
  }

  .close:hover {
    color: $primary;
  }
</style>
